import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: (resolve) => {
        require(['@/screens/Home'], resolve)
      }
    },
    {
      path: '/pdd',
      name: 'pddTool',
      component: (resolve) => {
        require(['@/screens/pdd/index'], resolve)
      }
    },
    {
      path: '/managePdd',
      name: 'managePddTool',
      component: (resolve) => {
        require(['@/screens/managePdd/index'], resolve)
      }
    },
    {
      path: '/iosAndroid',
      name: 'iosAndroid',
      component: (resolve) => {
        require(['@/screens/iosAndroid/index'], resolve)
      }
    },
    {
      path: '/iosAndroidDetail',
      name: 'iosAndroidDetail',
      component: (resolve) => {
        require(['@/screens/iosAndroid/detail'], resolve)
      }
    },
    {
      path: '/managePublicLib',
      name: 'managePublicLib',
      component: (resolve) => {
        require(['@/screens/managePublicLib/index'], resolve)
      }
    },
    {
      path: '/tmall',
      name: 'tmall',
      component: (resolve) => {
        require(['@/screens/tmall/home'], resolve)
      }
    },
    {
      path: '/tmallExcel',
      name: 'tmallExcel',
      component: (resolve) => {
        require(['@/screens/tmall/excel/index'], resolve)
      }
    },
    {
      path: '/tmallManagePublicLib',
      name: 'tmallManagePublicLib',
      component: (resolve) => {
        require(['@/screens/tmall/managePublicLib/index'], resolve)
      }
    },
    {
      path: '/tmallManageStore',
      name: 'tmallManageStore',
      component: (resolve) => {
        require(['@/screens/tmall/manageStore/index'], resolve)
      }
    },
    {
      path: '/tbAddress',
      name: 'tbAddress',
      component: (resolve) => {
        require(['@/screens/tb/tbToPdd'], resolve)
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  var needToHome = false
  if (!to.matched.length) {
    needToHome = true
  }
  if (needToHome) {
    next({
      path: '/'
    })
  } else {
    next()
  }
})

router.afterEach(() => {
  try {

  } catch (err) {

  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js